var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "newreturnsmanifest"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', {
    attrs: {
      "title": "Create Return Manifest"
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Go To Manifest Listing"
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "float": "right",
      "margin-top": "-55px",
      "margin-right": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "style": "font-size:18px; float:right; margin-top:-55px; margin-right:10px; cursor:pointer; "
    }
  })]), _vm._v(" "), (_vm.showCourier) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    ref: "courier",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "courier",
      "options": _vm.courierList1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.courierCompanyPlaceHolder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.courier),
      callback: function($$v) {
        _vm.courier = $$v
      },
      expression: "courier"
    }
  })], 1), _vm._v(" "), (_vm.courier == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.couriererr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createorShowManifest
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Create/Show Return Manifest")]), _vm._v(" \n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.courierCompany')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.courier) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnManifest.returnsManifestID')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.manifestid) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetManifestAction
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('b-form-fieldset', [(!_vm.showPrintUpload) ? _c('button', {
    staticClass: "btn btn-info mb-2",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeManifestAction
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.closingManifest')))]) : _vm._e(), _vm._v(" "), (_vm.showPrintUpload) ? _c('button', {
    staticClass: "btn btn-success mb-2",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printManifestAction
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('manifesthandover.printManifest')) + " ")]) : _vm._e(), _vm._v(" "), (_vm.showPrintUpload) ? _c('button', {
    staticClass: "btn btn-success mb-2",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.uploadManifestAction
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('returnManifest.uploadManifest')))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnManifest.addReturnAwb')))])])]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.awbNo')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "awbno",
      "placeholder": _vm.$t('common.aWBNumberPlaceHolder')
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addAWB($event)
      }
    },
    model: {
      value: (_vm.awbno),
      callback: function($$v) {
        _vm.awbno = $$v
      },
      expression: "awbno"
    }
  })], 1), _vm._v(" "), (_vm.awbno == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.aWBNumberError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.showPrintUpload
    },
    on: {
      "click": _vm.addAWB
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('srReport.add')) + " ")]), _vm._v(" \n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnManifest.addedReturnAwb')))])])]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('manifesthandover.totalAwb')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.totalAWBs))])]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifesthandover.SearchAWBno')) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-search'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('manifesthandover.SearchAWBno')
    },
    on: {
      "input": _vm.filterAWBs
    },
    model: {
      value: (_vm.awbnoForSearch),
      callback: function($$v) {
        _vm.awbnoForSearch = $$v
      },
      expression: "awbnoForSearch"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.showAWBDeatils) ? _c('div', {
    staticClass: "form-group row "
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "scrollable-table"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.awbNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('supportRequest.returnsType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.table.action')))])])])]), _vm._v(" "), _c('tbody', [(_vm.filteredAWBs.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredAWBs), function(awb) {
    return _c('tr', {
      key: awb.awbno
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(awb.awbno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(awb.returntype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.showPrintUpload
      },
      on: {
        "click": function($event) {
          _vm.showRemoveModal(awb.awbno)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listChannelData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]) : _vm._e()])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lm"
    },
    model: {
      value: (_vm.closeReturnsManifest),
      callback: function($$v) {
        _vm.closeReturnsManifest = $$v
      },
      expression: "closeReturnsManifest"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('returnManifest.closeReturnManifest')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeManifestModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('merchant.personName')) + "\n                        ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HandoverPersonName),
      expression: "HandoverPersonName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HandoverPersonName')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('handover.handoverpersonPlaceholder'),
      "name": "HandoverPersonName",
      "disabled": _vm.isdisableValue,
      "id": "HandoverPersonName"
    },
    domProps: {
      "value": (_vm.HandoverPersonName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.HandoverPersonName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.HandoverPersonName == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.HandoverPersonNameError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouses.contactPersonNumber')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactNO),
      expression: "contactNO"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric|min:10|max:10'),
      expression: "'numeric|min:10|max:10'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('contactNO')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('warehouses.contactPersonNumberPlaceHolder'),
      "name": "contactNO",
      "disabled": _vm.isdisableValue,
      "id": "contactNO"
    },
    domProps: {
      "value": (_vm.contactNO)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactNO = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('contactNO')),
      expression: "errors.has('contactNO')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contactNO')))]), _vm._v(" "), (_vm.contactNO == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.contactNOError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success mb-2",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.closeManifest
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger mb-2",
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetManifestModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.uploadReturnsManifest),
      callback: function($$v) {
        _vm.uploadReturnsManifest = $$v
      },
      expression: "uploadReturnsManifest"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('returnManifest.uploadReturnManifest')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUploadModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnManifest.uploadImage')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(!_vm.selectfileFlag) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chooseUpload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))]) : _vm._e(), _vm._v(" "), (_vm.selectfileFlag) ? _c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('rtogrnb2b.uploadProduct')
    },
    on: {
      "click": function($event) {
        _vm.uploadManifestImage('camera')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectfileFlag) ? _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('editedjson.selectProductLabel')
    },
    on: {
      "click": function($event) {
        _vm.uploadManifestImage('file')
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-md-10"
  }, [(!_vm.cameraSection && _vm.fileSection) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage('file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])])]) : _vm._e(), _vm._v(" "), (_vm.cameraSection && !_vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)]), _vm._v(" "), _c('web-cam', {
    ref: "cameraImage",
    attrs: {
      "autoplay": "autoplay",
      "playsinline": _vm.playsinline,
      "height": 300,
      "width": 800,
      "screenshotFormat": _vm.screenshotFormat,
      "selectFirstDevice": _vm.selectFirstDevice
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.captureImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.capture')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.resetImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.retake')))])]), _vm._v(" "), (this.imageCaptured) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.saveImage('camera')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.uploadedImages.length > 0) ? _c('div', {
    staticClass: "uploaded-images-container"
  }, [_c('div', {
    staticClass: "uploaded-images-sequence"
  }, _vm._l((_vm.uploadedImages), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "uploaded-image"
    }, [_c('img', {
      staticClass: "uploaded-img",
      attrs: {
        "src": image.url,
        "alt": 'Uploaded Image ' + index
      },
      on: {
        "click": function($event) {
          _vm.openImageInNewTab(image.url)
        }
      }
    })])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "20px",
      "float": "left"
    }
  }, [(_vm.uploadedImages.length > 0) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeUploadModal
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('packingb2b.b2bPacking.modal.close')))])]) : _vm._e()])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lm"
    },
    model: {
      value: (_vm.removeAWBConfirmModel),
      callback: function($$v) {
        _vm.removeAWBConfirmModel = $$v
      },
      expression: "removeAWBConfirmModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('returnManifest.returnManifest')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('returnManifest.removeAWBConfirm')) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-danger glasssec  float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.no')) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary glass float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmRemoveAWB
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.yes')) + "\n                      ")])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.printManifestModal),
      callback: function($$v) {
        _vm.printManifestModal = $$v
      },
      expression: "printManifestModal"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-12 printBody",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePrintModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestid')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifestid))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestDate')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifest_date) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.client')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.wmsclientname) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouse')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.wmswarehousename) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courier')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.PrintDetails.couriercompany) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.totalAwb')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.PrintDetails.awbcount) + " ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', [_c('div', {
    staticClass: "page-header-space"
  })])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "page"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.srNo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.awbNo')) + "#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Return Type")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.manifestDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.awbno) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.returntype))])])
  }))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.contactPerson')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.PrintDetails.deliveredby) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.contactNo')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("  " + _vm._s(_vm.PrintDetails.deliverycontact) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v("Taken By")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.PrintDetails.closedby))])])])])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "20px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.loading ? _vm.loadingText : _vm.$t('common.print'))
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('common.print')))])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lm"
    },
    model: {
      value: (_vm.isModalVisible),
      callback: function($$v) {
        _vm.isModalVisible = $$v
      },
      expression: "isModalVisible"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Courier")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Courier Name:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCourierDetails),
      expression: "otherCourierDetails"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('otherCourierDetails')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Courier Name",
      "name": "otherCourierDetails",
      "id": "otherCourierDetails"
    },
    domProps: {
      "value": (_vm.otherCourierDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherCourierDetails = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.otherCourierDetailsError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.otherCourierDetailsError))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.saveOtherCourier
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n                          " + _vm._s(_vm.$t('common.cancelBtn')) + "\n                        ")])])])])])])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d916850", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d916850","hasScoped":true}!./src/views/components/returnsmanifestlist/newreturnsmanifest/newreturnsmanifest.component.html
// module id = 2182
// module chunks = 0